export default __webpack_public_path__ + "static/media/marker-red-done.ab7522a0.svg";